import SEO from '../components/SEO';

const PROJECTS = [
  {
    title: 'E-commerce Website',
    description: 'An e-commerce website built with modern design principles.',
    img: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=600&q=80',
  },
  {
    title: 'Personal Blog Platform',
    description: 'Personal blog platform with a clean and easy to navigate interface.',
    img: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80',
  },
];

export default function Portfolio() {
  return (
    <div className="page container">
      <SEO
        title="Portfolio | Joan Christine Nyawira"
        description="A look at web and content projects by Joan Christine Nyawira, including e-commerce and blog platform builds."
        path="/portfolio"
      />
      <div className="section-header">
        <div>
          <div className="section-label">Work</div>
          <h2 className="section-title">Portfolio</h2>
        </div>
      </div>
      <div className="portfolio-grid">
        {PROJECTS.map((project) => (
          <article key={project.title} className="portfolio-card">
            <img src={project.img} alt={project.title} loading="lazy" />
            <div className="portfolio-card-body">
              <h2>{project.title}</h2>
              <p>{project.description}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
